module.exports = __webpack_public_path__ + "img/zdd_invite_jx_2.8b17dfa0.png";